export enum BACKEND_ERROR_STATUSES {
  INVALID_PASSWORD = 'invalid_password',
  REQUEST_CLOSED = 'err.diagram_authorisation.diagram_request_closed',
  NO_DIAGRAM_REQUEST = 'err.diagram_authorisation.no_diagram_request',
  TASK_ALREADY_CLOSED = 'err.diagram_authorisation.task_sign_off.already_completed',
  TASK_CANCELED = 'err.diagram_authorisation.task_sign_off.status_cancelled',
  TASK_REJECTED = 'err.diagram_authorisation.task_sign_off.status_rejected',
  TASK_APPROVED = 'err.diagram_authorisation.status_approved',
  TASK_COMPLETED = 'err.diagram_authorisation.status_completed',
  TASK_ALREADY_REJECTED = 'err.diagram_authorisation.status_already_rejected',
  TASK_SAME_STATUS = 'err.diagram_authorisation.task.same_status'
}
